export default __webpack_public_path__ + "static/media/afficheBlur.d19fbdff.jpg";